import { createSlice } from '@reduxjs/toolkit';

const dripData = createSlice({
  name: 'dripData',
  initialState: {
    refreshDripCardsData: false,
    refreshCardData: false
  },
  reducers: {
    updateRefreshDripCardsData: (state, action) => {
      state.refreshDripCardsData = action.payload
    },
    updateRefreshCardData: (state, action) => {
        state.refreshCardData = action.payload
    }
  },
});

export const { updateRefreshDripCardsData, updateRefreshCardData } = dripData.actions;

export default dripData.reducer;
